import { useEffect } from 'react';

import { Layout } from '../../../components';
import { CreditPoliciesPanel } from '../../../components/panels';
import { DRAWER_KEYS } from '../../../store/constants';

/**
 * Renders the List Credit Policies Page.
 *
 * This component displays the List Credit Policies Page, which includes an app bar, a drawer, and a credit policies panel.
 * The page title is set to "Políticas de Crédito | LCD".
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered ListCreditPolicyPage.
 */
const ListCreditPoliciesPage = () => {

    useEffect(() => {
        document.title = 'Políticas de Crédito | LCD'
    }, [])

    return (
        <Layout selectedKey={DRAWER_KEYS.CREDIT_POLICIES_LIST}>
            <CreditPoliciesPanel />
        </Layout>
    )
}

export default ListCreditPoliciesPage